module.exports = __webpack_public_path__ + "static/img/logo_white.4026717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/logo_white.png
// module id = 00OO
// module chunks = 41